<script>

	import Navigation from '@/components/Navigation/Navigation'
	import BottomFooter from '@/components/BottomFooter/BottomFooter'
	import Notification from '@/components/Notification/Notification'

	import 'normalize.css'
	import './styles/style.scss'

	export default {
		name: 'app',
		components: {
			Navigation,
			BottomFooter,
			Notification,
		},
		created () {
			this.$eventHub.$on('notification', this.toggleNotification);
		},
		data: () => ({
			notificationData: {
				show: false,
				type: '',
				message: '',
				duration: 0,
			}
		}),
		methods: {
			toggleNotification (notificationData) {
				this.notificationData = notificationData;
			},
		}
	}

</script>

<template>
	<div id='app' class='app'>
		<Notification
			:show='notificationData.show'
			:type='notificationData.type'
			:message='notificationData.message'
			:duration='notificationData.duration'
		/>
		<modal name='stripe-registration' :classes='"stripe-modal"'>
			stripe shit
		</modal>
		<div class='app-container'>
			<Navigation />
			<router-view />
			<BottomFooter />
		</div>
	</div>
</template>


// WEBPACK FOOTER //
// src/containers/App/App.vue